<app-modal-header [title]="'Change Password' | translate" [showCloseBtn]="!data?.requireNewPassword"
  (closeModal)="close()"></app-modal-header>

<div mat-dialog-content class="pt-4">
  <form [formGroup]="form" (ngSubmit)="submit()" class="grid grid-cols-1 gap-4">
    <!-- Current Password -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ 'Current Password' | translate }}</mat-label>
      <input matInput [type]="showCurrentPassword ? 'text' : 'password'" formControlName="currentPassword" />
      <button mat-icon-button matSuffix type="button" (click)="toggleShowCurrentPassword()"
        [attr.aria-label]="showCurrentPassword ? 'Hide password' : 'Show password'">
        <mat-icon>{{ showCurrentPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      @if (form.get('currentPassword')?.touched && form.get('currentPassword')?.hasError('required')) {
      <mat-error>{{ 'Current password is required' | translate }}</mat-error>
      }
    </mat-form-field>

    <!-- New Password -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ 'New Password' | translate }}</mat-label>
      <input matInput [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword" />
      <button mat-icon-button matSuffix type="button" (click)="toggleShowNewPassword()"
        [attr.aria-label]="showNewPassword ? 'Hide password' : 'Show password'">
        <mat-icon>{{ showNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      @if (form.get('newPassword')?.touched && form.get('newPassword')?.hasError('required')) {
      <mat-error>{{ 'New password is required' | translate }}</mat-error>
      }
      @if (form.get('newPassword')?.touched && form.get('newPassword')?.hasError('passwordStrength')) {
      <mat-error>
        {{ 'Password must be at least 8 characters long and contain uppercase, lowercase, number, and special character'
        | translate }}
      </mat-error>
      }
    </mat-form-field>

    <!-- Confirm Password -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ 'Confirm New Password' | translate }}</mat-label>
      <input matInput [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" />
      <button mat-icon-button matSuffix type="button" (click)="toggleShowConfirmPassword()"
        [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'">
        <mat-icon>{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
      @if (form.get('confirmPassword')?.touched && form.get('confirmPassword')?.hasError('required')) {
      <mat-error>{{ 'Confirm password is required' | translate }}</mat-error>
      }
      @if (form.get('confirmPassword')?.touched && form.get('confirmPassword')?.hasError('mismatch')) {
      <mat-error>{{ 'Passwords do not match' | translate }}</mat-error>
      }
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions align="end" class="pb-4 px-6">
  @if (!data?.requireNewPassword) {
  <button mat-button type="button" (click)="close()" [disabled]="submitting">
    {{ 'Cancel' | translate }}
  </button>
  }
  <button mat-raised-button color="primary" type="button" (click)="submit()" [disabled]="form.invalid || submitting"
    class="ml-2">
    @if (submitting) {
    <mat-spinner diameter="18"></mat-spinner>
    } @else {
    {{ 'Change Password' | translate }}
    }
  </button>
</div>